export const PROBATE_LAYOUT_VIEW = "vertical";

export const getSelectedStateLabel = () => {
  const s = localStorage.getItem("selectedState");
  try {
    return s ? JSON.parse(s).label : "Florida";
  } catch {
    return "Florida";
  }
};

export const standardStep = (Component, stateKey, getProps) => ({
  Component,
  stateKey,
  getProps,
});
